import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const API = 'https://tribaltech-backend.onrender.com';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 8) return setError('Password must be at least 8 characters');
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setDone(true);
    } catch (e) {
      setError(e.message || 'Something went wrong');
    }
    setLoading(false);
  };

  if (!token) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', color:'var(--offwhite)' }}>
      <div className="card" style={{ width: 400, textAlign:'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
        <h2 style={{ marginBottom: 12 }}>Invalid reset link</h2>
        <p style={{ color:'var(--muted)', fontSize: 14, marginBottom: 20 }}>This link is missing a token. Please request a new one.</p>
        <Link to="/forgot-password" className="btn btn-primary">Request new link</Link>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ width: 400 }}>
        <div style={{ textAlign:'center', marginBottom: 32 }}>
          <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--purple-light)', marginBottom: 8 }}>CREATOR PROTECT</div>
          <div style={{ color: 'var(--muted)', fontSize: 14 }}>Content protection for creators</div>
        </div>

        <div className="card">
          {done ? (
            <div style={{ textAlign:'center', padding: '8px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
              <h2 style={{ marginBottom: 12, fontSize: 18 }}>Password updated</h2>
              <p style={{ color:'var(--muted)', fontSize: 14, marginBottom: 24 }}>Your password has been changed. You can now sign in.</p>
              <Link to="/login" className="btn btn-primary" style={{ display:'inline-block' }}>Sign in</Link>
            </div>
          ) : (
            <>
              <h2 style={{ marginBottom: 8, fontSize: 18 }}>Set new password</h2>
              <p style={{ color:'var(--muted)', fontSize: 14, marginBottom: 24 }}>Choose a strong password for your account.</p>

              {error && (
                <div style={{ background:'#7F1D1D', color:'#FCA5A5', padding:'10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, color:'var(--muted)', display:'block', marginBottom: 6 }}>New password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 8 characters" required />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label style={{ fontSize: 13, color:'var(--muted)', display:'block', marginBottom: 6 }}>Confirm password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" required />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width:'100%' }} disabled={loading}>
                  {loading ? 'Updating...' : 'Update password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
